import { network } from './network';

export async function loginWithGoogle(opts) {
	const res = await network({
		url: '/api/v1/login/web/google',
		method: 'post',
		headers: {},
		params: {
			...opts
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function loginWithApple(opts) {
	const res = await network({
		url: '/api/v1/login/web/apple',
		method: 'post',
		headers: {},
		params: {
			...opts
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function getShopTicket(opts) {
	const res = await network({
		url: '/api/v1/app/shop_ticket',
		method: 'post',
		headers: {
			token: opts.token
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function deleteAccount(opts) {
	const res = await network({
		url: '/api/v1/del_user',
		method: 'post',
		params: {},
		headers: {
			token: opts.token
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function loginout(opts) {
	const res = await network({
		url: '/api/v1/user/logout',
		method: 'post',
		params: {},
		headers: {
			token: opts.token
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}